import React, { useState } from "react";
import { Button, Modal } from "antd";


const DeleteItemModal = ({ onDelete, item, buttonType, text }) => {
  const [visible, setVisible] = useState(false);

  const handleDelete = () => {
    onDelete(item); // Pass the item to the onDelete handler
    setVisible(false); // Close the modal after delete action
  };

  const showModal = () => {
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <>
      <Button type={buttonType || "link"} onClick={showModal}>
        {text || "Delete"}
      </Button>
      <Modal
        title="Confirm Delete"
        visible={visible}
        onOk={handleDelete}
        onCancel={handleCancel}
        okText="Delete"
        cancelText="Cancel"
      >
        <p>Are you sure you want to delete {item.name}?</p>
      </Modal>
    </>
  );
};

export default DeleteItemModal;
